import React from 'react'
import { UserPaymentsProvider } from '../context/UserPaymentsProvider'
import { PayoutToAchFlow } from './PayoutToAch/PayoutToAchFlow'
import { CancelBonusFlow } from './CancelBonus/CancelBonusFlow'

type UserPaymentsScopeProps = React.ComponentProps<typeof UserPaymentsProvider>

export const UserPaymentsScope = ({
  children,
  ...providerProps
}: UserPaymentsScopeProps) => (
  <UserPaymentsProvider {...providerProps}>
    {children}
    <PayoutToAchFlow />
    <CancelBonusFlow />
  </UserPaymentsProvider>
)
